'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var 意傳服務 = function 意傳服務() {};
var self = 意傳服務;

意傳服務.網域 = function () {
  return "https://hts.ithuan.tw/";
};

意傳服務.語音合成 = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ = _ref.分詞,
      分詞 = _ref$ === undefined ? '' : _ref$,
      _ref$2 = _ref.腔口,
      腔口 = _ref$2 === undefined ? '' : _ref$2;

  return encodeURI(self.網域() + '\u8A9E\u97F3\u5408\u6210?\u67E5\u8A62\u8154\u53E3=' + 腔口 + '&\u67E5\u8A62\u8A9E\u53E5=' + 分詞);
};

意傳服務.文本直接合成 = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$ = _ref2.腔口,
      腔口 = _ref2$ === undefined ? '' : _ref2$,
      _ref2$2 = _ref2.語句,
      語句 = _ref2$2 === undefined ? '' : _ref2$2;

  return encodeURI(self.網域() + '\u6587\u672C\u76F4\u63A5\u5408\u6210?\u67E5\u8A62\u8154\u53E3=' + 腔口 + '&\u67E5\u8A62\u8A9E\u53E5=' + 語句);
};

exports.default = 意傳服務;


//////////////////
// WEBPACK FOOTER
// ./node_modules/demo-ui/lib/api/意傳服務.js
// module id = 9
// module chunks = 0